import React from "react";
import { Box, Button, Typography } from "@mui/material";

const DEFAULT_BORDER = "#29ABFF";
const DEFAULT_TITLE = "#3451F4";
const DEFAULT_ACTION = "#9C4FFF";

export default function TabSectionHeader({
  title,
  rightText = "",
  onAction,
  actionNode = null,
  actionDisabled = false,
  actionStartIcon = null,
  sx = {},
  titleSx = {},
  actionSx = {},
  dividerColor = DEFAULT_BORDER,
}) {
  return (
    <Box
      sx={{
        borderTop: `1px solid ${dividerColor}`,
        borderBottom: `1px solid ${dividerColor}`,
        py: 3,
        mb: 4,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "nowrap",
        ...sx,
      }}
    >
      <Typography
        className="profile-section-title"
        sx={{
          fontSize: 20,
          fontWeight: 700,
          color: DEFAULT_TITLE,
          fontFamily: "Be Vietnam Pro",
          lineHeight: "30px",
          flex: 1,
          minWidth: 0,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...titleSx,
        }}
      >
        {title}
      </Typography>

      {actionNode ? (
        actionNode
      ) : rightText ? (
        <Button
          className="tab-section-action"
          variant="text"
          size="small"
          disableRipple
          startIcon={actionStartIcon}
          onClick={onAction}
          disabled={actionDisabled}
          sx={{
            flexShrink: 0,
            minWidth: "auto",
            minHeight: "auto",
            px: 0,
            py: 0,
            textTransform: "none",
            fontSize: 14,
            fontWeight: 400,
            color: actionDisabled ? "#98A2B3" : DEFAULT_ACTION,
            fontFamily: "Be Vietnam Pro",
            lineHeight: "24px",
            letterSpacing: 0,
            "& .MuiButton-startIcon": {
              mr: 0.5,
            },
            "&:hover": {
              backgroundColor: "transparent",
              opacity: actionDisabled ? 1 : 0.92,
            },
            ...actionSx,
          }}
        >
          {rightText}
        </Button>
      ) : null}
    </Box>
  );
}
